import {ConfigProvider, App } from "antd";
import {createHashRouter, RouterProvider} from "react-router-dom";
import { driverRoutes } from "./components/routes/driverRoutes";
import {Suspense, useEffect, useState} from "react";
import CentralLoading from "./components/layout/CentralLoading";
import {dpComponentColour, dpPanelColour} from "./theme/theme-variables";
import { getMapsApiKey } from "./api/location";
import { storeSessionData } from "./utility/global-util";
import GlobalContext from "./GlobalContext";
import { getApplicationVersion } from "./api/security";
import { initializeWebPush } from "./utility/webpush-util";

/**
 * The main application wrapper.
 * This will always be at the root of the application.
 *
 * Provides context vales and routing to everything.
 */
export default function DriverApp() {
    const router = createHashRouter(driverRoutes);


    // GLOBAL DATA
    const [currentRouteId, setCurrentRouteId] = useState(null);
    const [currentPath, setCurrentPath] = useState(null);
    const [vehicleHeader, setVehicleHeader] = useState(null);
    const [vehicleHeaderTrans, setVehicleHeaderTrans] = useState(null);
    const [currentTabBarId, setCurrentTabBarId] = useState(null);
    const [currentBackRouteId, setCurrentBackRouteId] = useState(null);
    const [currentBackRouteTrans, setCurrentBackRouteTrans] = useState(null);
    const [requestedRoute, setRequestedRoute] = useState(null);
    const [contractNo, setContractNo] = useState(null);

    const globalData = {
        currentRouteId, setCurrentRouteId,
        currentPath, setCurrentPath,
        vehicleHeader, setVehicleHeader,
        vehicleHeaderTrans, setVehicleHeaderTrans,
        currentTabBarId, setCurrentTabBarId,
        currentBackRouteId, setCurrentBackRouteId,
        currentBackRouteTrans, setCurrentBackRouteTrans,
        requestedRoute, setRequestedRoute,
        contractNo, setContractNo,
    }

    initializeWebPush();

    // Google Maps
    useEffect(() => {
      getMapsApiKey().then(res => {
        // process.env.REACT_APP_MAPS_KEY = res;
        storeSessionData('REACT_APP_MAPS_KEY', res);
      }).catch(err => console.log(err));

      getApplicationVersion().then((res) => {
        storeSessionData('APP_VERSION', res);
      }).catch(err => {
        console.log(err);
      });
    }, []
  )

    // APP WRAPPER
    return (
        <ConfigProvider
             theme={{
                token: {
                  // Seed token for primary colour override on ant components
                  colorPrimary: dpComponentColour,
                  fontFamily: "'Poppins', sans-serif",
                },
                components: {
                    Layout: {
                      headerBg: dpPanelColour,
                      bodyBg: dpPanelColour,
                      footerBg: dpPanelColour,
                      headerHeight: "auto",
                      headerPadding: 0,
                      footerPadding: 0
                    },
                  },
             }}
        >
            <Suspense fallback={<CentralLoading />}>
                <App>
                    <GlobalContext.Provider value={globalData}>
                        <RouterProvider router={router} />
                    </GlobalContext.Provider>
                </App>
            </Suspense>
        </ConfigProvider>
  );
}
